import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BaseFieldComponent } from '../base-field.component';

@Component({
  selector: 'app-date-field',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  template: `
    <div class="field-wrapper" [class]="field.cssClass" [class.has-error]="isInvalid">

      <label [for]="field.id">
        {{ field.label }}<a *ngIf="hasLabelLink" [href]="field.linkUrl" [target]="field.linkTarget ?? '_blank'" [attr.rel]="(field.linkTarget ?? '_blank') === '_blank' ? 'noopener noreferrer' : null">{{ field.linkText }}</a>
        <span *ngIf="hasRequired" class="required-mark">*</span>
      </label>

      <input
        [id]="field.id"
        type="date"
        [formControl]="control"
        [attr.min]="resolvedMin || null"
        [attr.max]="resolvedMax || null"
        [attr.aria-describedby]="field.hint ? field.id + '-hint' : null"
      />

      <small *ngIf="field.hint && !isInvalid"
             [id]="field.id + '-hint'">
        {{ field.hint }}
      </small>

      <small *ngIf="isInvalid" class="error">
        {{ errorMessage }}
      </small>

    </div>
  `
})
export class DateFieldComponent extends BaseFieldComponent {

  get resolvedMin(): string {
    const props = (this.field?.customProps as Record<string, unknown>) ?? {};
    return this.resolveDate(props['minDate'] as string | undefined);
  }

  get resolvedMax(): string {
    const props = (this.field?.customProps as Record<string, unknown>) ?? {};
    return this.resolveDate(props['maxDate'] as string | undefined);
  }

  private resolveDate(value: string | undefined): string {
    if (!value) return '';
    if (value === 'today') return this.todayISO();
    return value;
  }

  private todayISO(): string {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  }

  get hasRequired(): boolean {
    return !!this.field.validations?.some(v => v.type === 'required');
  }
}

